import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { Col } from 'react-styled-flexboxgrid';
import { PrivateInputV3 } from '../TextInputsV3/PrivateInputV3';
import { Input as TextareaInput } from '../../Form/FormBuilder/TextareaInput';
import { SeparatorBuilder } from '../../Form/FormBuilder/SeparatorBuilder';
import { PasswordInputV4CompatibilityWrapper } from './PasswordInputV4CompatibilityWrapper';
import { SelectInputV3CompatibilityWrapper } from './SelectInputV3CompatibilityWrapper';
import { TextInputV3CompatibilityWrapper } from './TextInputV3CompatibilityWrapper';
import { StyledCheckboxInput, StyledDateInput } from './styled-components';
var inputMap = {
  checkbox: StyledCheckboxInput,
  date: StyledDateInput,
  number: TextInputV3CompatibilityWrapper,
  "private": PrivateInputV3,
  password: PasswordInputV4CompatibilityWrapper,
  select: SelectInputV3CompatibilityWrapper,
  separator: SeparatorBuilder,
  text: TextInputV3CompatibilityWrapper,
  tel: TextInputV3CompatibilityWrapper,
  textarea: TextareaInput
};

var FormItemV3 = function FormItemV3(_ref) {
  var type = _ref.type,
      _ref$sizes = _ref.sizes,
      sizes = _ref$sizes === void 0 ? {} : _ref$sizes,
      props = _objectWithoutProperties(_ref, ["type", "sizes"]);

  var Component = typeof type === 'string' ? inputMap[type] : type;
  var _sizes$md = sizes.md,
      md = _sizes$md === void 0 ? 6 : _sizes$md,
      _sizes$sm = sizes.sm,
      sm = _sizes$sm === void 0 ? 12 : _sizes$sm,
      _sizes$xs = sizes.xs,
      xs = _sizes$xs === void 0 ? 12 : _sizes$xs;
  var altType = ['text', 'number', 'password', 'tel'].includes(type) ? type : null;
  return /*#__PURE__*/React.createElement(Col, {
    md: md,
    sm: sm,
    xs: xs
  }, /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    type: altType
  })));
};

export { FormItemV3 };